/* ------------------------------------------------------------------
   RAVA - TERMS ACCEPTANCE

   Holds the checkout button until the box is ticked, and records the
   acceptance on the cart so it reaches the order.

   The button is left clickable and marked aria-disabled rather than
   given the disabled attribute, because a disabled button gives no
   feedback at all: the customer clicks, nothing happens, and they have
   no idea why. This way the click is intercepted and the reason is
   shown.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function checkoutButtons() {
    return document.querySelectorAll('button[name="checkout"], .cart__checkout-button');
  }

  function setAttribute(value) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Terms accepted': value } })
    }).catch(function () {});
  }

  function sync(wrapper, input) {
    var ok = input.checked;
    var buttons = checkoutButtons();
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-disabled', ok ? 'false' : 'true');
    }
    if (ok) wrapper.classList.remove('rava-terms--warn');
  }

  function init(wrapper) {
    if (wrapper.dataset.ravaTermsReady === 'true') return;
    wrapper.dataset.ravaTermsReady = 'true';

    var input = wrapper.querySelector('[data-rava-terms-input]');
    if (!input) return;

    sync(wrapper, input);

    input.addEventListener('change', function () {
      sync(wrapper, input);
      if (input.checked) {
        setAttribute(new Date().toISOString());
      } else {
        setAttribute('');
      }
    });
  }

  // One capture-phase listener for the whole document, so it keeps working
  // after the drawer replaces its own markup.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('button[name="checkout"], .cart__checkout-button');
      if (!button) return;
      if (button.getAttribute('aria-disabled') !== 'true') return;

      event.preventDefault();
      event.stopPropagation();

      var wrapper = document.querySelector('[data-rava-terms]');
      if (wrapper) {
        wrapper.classList.add('rava-terms--warn');
        var input = wrapper.querySelector('[data-rava-terms-input]');
        if (input) input.focus();
        wrapper.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    },
    true
  );

  function scan() {
    var nodes = document.querySelectorAll('[data-rava-terms]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  document.addEventListener('DOMContentLoaded', scan);
  scan();

  var drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(scan).observe(drawer, { childList: true, subtree: true });
})();
